import React from 'react';
import styled from 'styled-components';
import { sectionMargins } from '../styles';
import { Container, HtmlContent } from './ui';
import { hasStructuredText } from '../utils';

const StyledBlogDetailIntroduction = styled.section`
  ${sectionMargins('20px', '40px')};
`;

const StyledContainer = styled(Container)`
  padding-left: 0;
  padding-right: 0;
`;

const StyledIntroduction = styled(HtmlContent)``;

const BlogDetailIntroduction = ({ introduction }) => (
  <>
    {hasStructuredText(introduction) && (
      <StyledBlogDetailIntroduction>
        <StyledContainer narrower={true}>
          <StyledIntroduction content={introduction} />
        </StyledContainer>
      </StyledBlogDetailIntroduction>
    )}
  </>
);

export default BlogDetailIntroduction;
